import { render } from "./WildBookFallData.vue?vue&type=template&id=091cb927&scoped=true&ts=true"
import script from "./WildBookFallData.vue?vue&type=script&lang=ts"
export * from "./WildBookFallData.vue?vue&type=script&lang=ts"

import "./WildBookFallData.vue?vue&type=style&index=0&id=091cb927&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091cb927"]])

export default __exports__